<template>
  <div class="row">
    <el-drawer title="" :visible.sync="showForm" direction="btt" :before-close="handleClose" size="90%"
      :destroy-on-close="true" :append-to-body="true" >
      <div class="row">
        <div class="col-md-4"></div>
        <div class="col-md-4">
          <UserReportSeriesNumberForm @save="getSeriesNumbers()" v-if="showForm" :series_number="selected" :date="report_form.start_date"></UserReportSeriesNumberForm>
        </div>
      </div>

    </el-drawer>

    <div class="col-md-12 card">
      <div class="card-header">
        <div class="category">Series Numbers</div>
      </div>
      <div class="card-body row">
        <div class="col-sm-12" v-if="report_form">
           <div v-if="report_form.start_date != report_form.end_date">
             Date: {{ report_form.start_date }}  to  {{ report_form.end_date }}
           </div>
           <div v-else>Date: {{ report_form.end_date }}</div>
        </div>
        <div class="col-sm-12 mt-2">
          <el-table class="table-striped" header-row-class-name="text-primary" :data="series_numbers" style="width: 100%" v-if="series_numbers.length">
            <el-table-column :min-width="120"  class-name="td-actions" label="Date" v-if="report_form.start_date != report_form.end_date">
              <template slot-scope="props">
                {{ props.row.date }}
              </template>
            </el-table-column>
            <el-table-column :min-width="120"  class-name="td-actions" label="Start">
              <template slot-scope="props">
                {{ props.row.start }}
              </template>
            </el-table-column>

            <el-table-column :min-width="120"  class-name="td-actions" label="End">
              <template slot-scope="props">
                {{ props.row.end }}
              </template>
            </el-table-column>

            <el-table-column :min-width="120"  class-name="td-actions" label="Actions">
              <template slot-scope="props">

                <el-button type="default" link @click="handleEdit(props.row)" size="mini" v-if="props.row.is_editable">
                  <i class="fa fa-edit"></i>
                </el-button>
                <confirm-delete @onClick="handleDelete(props.row)" :label="'Delete'" v-if="props.row.is_editable"></confirm-delete>
              </template>
            </el-table-column>
          </el-table>
          <div style="text-align: center;"><el-button type="primary" size="small" class="ml-2" @click="handleForm">Add Series Numbers</el-button></div>
        </div>
      </div>
    </div>

    <div style="text-align: center;">
        <el-alert :closable="false" type="warning">
            <div style="font-size: 20px;">Please add at least one series number range from the tickets you’ve issued to generate the report.</div>
        </el-alert>
        <el-button type="primary" :disabled="!series_numbers.length" @click="handleGenerateReport">GENERATE REPORT</el-button>
    </div>
  </div>
</template>
<script>

import { ReportSeriesNumber } from '@/resources/report_series_number'
import ConfirmDelete from '@/components/Common/ConfirmDelete.vue'
import UserReportSeriesNumberForm from './UserReportSeriesNumberForm.vue'

export default {
  components: { ConfirmDelete, UserReportSeriesNumberForm },
  props: ['report_form'],
  data() {
    return {
      showDelete: false,
      showForm: false,
      series_numbers: [],
      selected: null,
      perPageOptions: [5, 10, 15],
      pagination: {
        perPage: 10,
        currentPage: 1,
        total: 0
      },
      term: null,
    }
  },
  created: function () {
    this.getSeriesNumbers()
  },
  methods: {
    handleEdit(model) {
      this.showForm = true
      this.selected = Object.assign({}, model)
    },
    handleClose() {
      this.showDelete = false
      this.showForm = false
    },
    handleForm() {
      this.showForm = true
      this.selected = null
    },
    handleGenerateReport() {
        this.$emit('generate', this.series_numbers)
    },
    handleDelete(model) {
      this.$loading = true
      this.$loadingText = "Removing"

      ReportSeriesNumber.delete({ id: model.id })
        .then(result => {
          this.$notify({
            type: 'success',
            title: "Success",
            text: 'Series has been removed',
          });
          this.getSeriesNumbers()
        })
        .catch(() => {

        }).finally(() => {
          this.$loading = false
        })
    },
    getSeriesNumbers() {
      this.handleClose()
      let params = { term: this.term, status: this.status, page: this.pagination.currentPage, 
        per_page: this.pagination.perPage,
        start_date: this.report_form.start_date,
        end_date: this.report_form.end_date
      }
      this.$loading = true
      ReportSeriesNumber.get({ params: params })
        .then(result => {
          if (result.data.report_series_numbers)
            this.series_numbers = result.data.report_series_numbers
        })
        .catch(() => {
          this.$notify({
            type: 'danger',
            title: "Error",
            text: 'Unable to fetch series numbers',
          });

        }).finally(() => {
          this.$loading = false
        })
    }
  }
}
</script>
<style lang="scss"></style>
